var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20424_14350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4583 0H1.54167C0.690228 0 0 0.690228 0 1.54167V14.4583C0 15.3098 0.690228 16 1.54167 16H14.4583C15.3098 16 16 15.3098 16 14.4583V1.54167C16 0.690228 15.3098 0 14.4583 0Z",
    fill: "#F58220"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 10.668H5.99984C5.62484 10.668 5.2915 10.3763 5.2915 10.0013C5.2915 9.6263 5.62484 9.33463 5.99984 9.33463H9.99984C10.3748 9.33463 10.6665 9.6263 10.6665 10.0013C10.6665 10.3763 10.3748 10.668 9.99984 10.668ZM5.99984 5.29297H7.95817C8.33317 5.29297 8.62484 5.58464 8.62484 5.95964C8.62484 6.33464 8.33317 6.6263 7.95817 6.6263H5.99984C5.62484 6.6263 5.2915 6.33464 5.2915 5.95964C5.2915 5.58464 5.62484 5.29297 5.99984 5.29297ZM13.5415 7.04297L13.4582 6.83464L13.2915 6.70964C13.0832 6.58464 12.0415 6.7513 11.7498 6.5013C11.5832 6.29297 11.5415 5.95964 11.4582 5.54297C11.3748 4.66797 11.2915 4.6263 11.1665 4.33464C10.6665 3.29297 9.33317 2.5013 8.4165 2.41797H5.95817C3.99984 2.41797 2.4165 4.0013 2.4165 5.91797V10.043C2.4165 12.0013 3.99984 13.5846 5.95817 13.5846H9.99984C11.9582 13.5846 13.5415 12.0013 13.5415 10.043L13.5832 7.70964V7.20964L13.5415 7.04297Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20424_14350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.cbf2bf27bcf5a331f5be094e790453da.svg";
export { ForwardRef as ReactComponent };